import { f as r } from "./function-uncurry-this.js";
var t = Error,
  a = r("".replace),
  e = String(t("zxcasd").stack),
  n = /\n\s*at [^:]*:[^\n]*/,
  c = n.test(e),
  o = function o(r, e) {
    if (c && "string" == typeof r && !t.prepareStackTrace) for (; e--;) r = a(r, n, "");
    return r;
  };
export { o as e };